"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
/**
 * Note API sdk
 * @deprecated
 */
class Note {
    constructor() {
        console.warn('Notes are deprecated. Please use nodes instead');
        if (!(authData_1.Auth.getUserToken() && authData_1.Auth.getDomainToken())) {
            throw new Error("Cannot use Note service without authenticated user and opened domain!, " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    /**
     * Returns all domain's notes
     * @returns Promise<iNote[]>
     */
    all() {
        return this.api.get(`note`);
    }
    /**
     * Create Node based on iNoteCreate params
     * @param data
     * @returns Promise<iNote>
     */
    create(data) {
        return this.api.post(`note`, data);
    }
    /**
     * Update a note based on id
     *
     * @param id
     * @param data
     * @returns Promise<iNote>
     */
    update(id, data) {
        return this.api.patch(`note/${id}`, data);
    }
    /**
     * Delete a note based on id
     *
     * @param id: string | number
     * @returns
     */
    delete(id) {
        return this.api.delete(`note/${id}`);
    }
}
exports.Note = Note;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wdWJsaWMvc2VydmljZXMvbm90ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFBaUU7QUFDakUsK0RBQXdEO0FBSXhEOzs7R0FHRztBQUNILE1BQWEsSUFBSTtJQUdmO1FBRUUsT0FBTyxDQUFDLElBQUksQ0FBQyxnREFBZ0QsQ0FBQyxDQUFBO1FBRTlELElBQUksQ0FBQyxDQUFDLGVBQUksQ0FBQyxZQUFZLEVBQUUsSUFBSSxlQUFJLENBQUMsY0FBYyxFQUFFLENBQUMsRUFBRTtZQUNuRCxNQUFNLElBQUksS0FBSyxDQUNiLHlFQUF5RTtnQkFDdkUsNENBQTRDLENBQy9DLENBQUM7U0FDSDtRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxxQkFBUyxDQUFRLGVBQUksQ0FBQyxZQUFZLEVBQUUsRUFBRSxlQUFJLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQztJQUM5RSxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksR0FBRztRQUNSLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQVUsTUFBTSxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxNQUFNLENBQUMsSUFBaUI7UUFDN0IsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBUSxNQUFNLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLE1BQU0sQ0FBQyxFQUFtQixFQUFFLElBQTBCO1FBQzNELE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQVEsUUFBUSxFQUFFLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNuRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsRUFBbUI7UUFDL0IsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdkMsQ0FBQztDQUNGO0FBdERELG9CQXNEQyJ9